import React, { useState } from "react";

import theme, {
  styles as commonStyles,
  navbarHeight,
} from "../../../utils/styles";
import data from "../../../data/landing";

import Fade from "react-reveal/Fade";
import Zoom from "react-reveal/Zoom";
import HeadShake from "react-reveal/HeadShake";

const bannerImagePath = "/img/banner.png";

const Landing = (props) => {
  const { yOffset } = props;
  const { isBreakpoint } = props;

  const documentHeight = window.innerHeight;
  let scrolledPercentage = Math.floor((yOffset / documentHeight) * 100);

  if (scrolledPercentage > 10) {
    scrolledPercentage = 100;
  }

  const opacity = String(100 - scrolledPercentage) + "%";

  const executeScroll = (id) => {
    if (document.location.pathname === "/") {
      if (id[0] === "/") {
        window.location.href = id;
      } else {
        const traget = document.getElementById(id);
        window.history.pushState({}, "", "/" + id);
        traget.scrollIntoView();
      }
    } else {
      if (id[0] !== "/") {
        window.location.href = "/" + id;
      }
    }
  };

  const [buttonHover, setButtonHover] = useState(false);

  const renderHeadingText = (index, color) => {
    const headingText = data.heading.split(" ");
    return <div style={styles.headingText(color)}>{headingText[index]}</div>;
  };

  const renderHeading = (
    <div style={styles.heading}>
      <Fade
        left
        delay={(textRevealDuration / 2) * 1}
        duration={textRevealDuration}
      >
        {renderHeadingText(0, "white")}
      </Fade>
      <Fade
        left
        delay={(textRevealDuration / 2) * 2}
        duration={textRevealDuration}
      >
        {renderHeadingText(1, theme.colors.primary)}
      </Fade>
      <Fade
        left
        delay={(textRevealDuration / 2) * 3}
        duration={textRevealDuration}
      >
        {renderHeadingText(2, "white")}
      </Fade>
      <Fade
        left
        delay={(textRevealDuration / 2) * 4}
        duration={textRevealDuration}
      >
        {renderHeadingText(3, theme.colors.secondary)}
      </Fade>
    </div>
  );

  return (
    <div style={styles.bg} id="#landing">
      <div style={styles.root(opacity)}>
        <div style={styles.bannerTextBackground}>
          <div
            style={{
              ...styles.bannerTextContainer,
              width: isBreakpoint ? "80%" : "100%",
              paddingTop: isBreakpoint ? navbarHeight : 0,
            }}
          >
            {renderHeading}
            <Fade
              left
              delay={(textRevealDuration / 2) * 5}
              duration={textRevealDuration}
            >
              <div style={styles.subHeadingText}>{data.subHeading}</div>
            </Fade>

            <div style={styles.ctaButtonContainer}>
              <Zoom
                delay={(textRevealDuration / 2) * 6}
                duration={textRevealDuration}
              >
                <HeadShake when={buttonHover}>
                  <button
                    style={commonStyles.ctaButton(buttonHover)}
                    onMouseEnter={(e) => {
                      setButtonHover(true);
                    }}
                    onMouseLeave={(e) => {
                      setButtonHover(false);
                    }}
                    onClick={(e) => {
                      executeScroll("#mission");
                    }}
                  >
                    Learn More
                  </button>
                </HeadShake>
              </Zoom>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;

const styles = {
  bg: {
    background: theme.colors.background,
  },
  root: (opacity) => ({
    height: "100vh",
    opacity: opacity,
    transition: "ease-in-out 0.5s",
    background: `url(${bannerImagePath})`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }),
  bannerTextBackground: {
    width: "100%",
    height: "100%",
    backgroundColor: "rgb(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  bannerTextContainer: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },

  heading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    rowGap: 10,
    columnGap: 10,
  },

  headingText: (color) => ({
    textTransform: "uppercase",
    color: color,
    fontSize: "7vh",
    fontWeight: "bold",
    wordWrap: "normal",
    display: "inline",
  }),

  subHeadingText: {
    width: "80vw",
    color: "white",
    fontSize: "3vh",
    textAlign: "center",
    wordWrap: "normal",
    marginTop: 20,
  },

  ctaButtonContainer: {
    marginTop: 50,
  },
};

const textRevealDuration = 400;
